import type { InputHTMLAttributes } from "react";
import { cn } from "@/lib/cn";

export type InputProps = InputHTMLAttributes<HTMLInputElement> & {
  invalid?: boolean;
};

export function Input({ className, invalid, ...props }: InputProps) {
  return (
    <input
      className={cn(
        "h-10 w-full rounded-lg border bg-surface px-3 text-sm text-fg outline-none transition-colors placeholder:text-fg-subtle focus-visible:ring-2 focus-visible:ring-ring/30 disabled:cursor-not-allowed disabled:opacity-50",
        invalid
          ? "border-danger focus-visible:ring-danger/30"
          : "border-border focus-visible:border-primary",
        className,
      )}
      {...props}
    />
  );
}
